import React from 'react';
import logoMark from '../img/LOGOMARK-PUREBLACK.png';

const StarIcon8Point = ({ onClick, dataPage, className = '' }) => {
  const handleClick = (e) => {
    if (onClick && dataPage) {
      e.preventDefault();
      onClick(dataPage);
    }
  };

  return (
    <img
      src={logoMark}
      alt="AIDEA logo mark"
      className={`star-icon-8point ${className}`}
      onClick={handleClick}
      data-page={dataPage}
      style={{ cursor: dataPage ? 'pointer' : 'default' }}
    />
  );
};

export default StarIcon8Point;
